import React, { useEffect, useState } from 'react';
import '.././App.css';
import { auth, db } from '../firebase';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function Header() {
    const [pumpName, setPumpName] = useState("Loading...");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
            if (user) {
                const userDocRef = doc(db, "Users", user.uid);

                const unsubscribeDoc = onSnapshot(userDocRef, async (docSnap) => {
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setPumpName(data.pumpName || data.email || "My Petrol Pump");

                        // --- EXPIRY & STATUS LOGIC ---
                        if (data.expiryDate) {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            const expiry = new Date(data.expiryDate);
                            expiry.setHours(0, 0, 0, 0);

                            // 1. Check if Expired
                            if (today > expiry) {
                                if (data.status !== "Inactive") {
                                    // Auto-update status in Firebase if expired
                                    await updateDoc(userDocRef, { status: "Inactive" });
                                }
                                navigate("/make-payment");
                            } 
                            
                            // 2. Check if Expiry is within 15 days (Daily Alert)
                            else {
                                const diffTime = expiry - today;
                                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                                if (diffDays <= 15 && diffDays >= 0) {
                                    const lastAlertDate = localStorage.getItem('lastExpiryAlert');
                                    const todayString = today.toDateString();

                                    // Only show if not alerted today
                                    if (lastAlertDate !== todayString) {
                                        Swal.fire({
                                            title: 'Subscription Reminder',
                                            text: `Your service expires in ${diffDays} days (${data.expiryDate}). Please contact Rohan Thorat at 8459432930 for renewal.`,
                                            icon: 'warning',
                                            confirmButtonColor: '#d33',
                                        });
                                        localStorage.setItem('lastExpiryAlert', todayString);
                                    }
                                }
                            }
                        }

                        // Direct Inactive Check (for manual changes)
                        if (data.status === "Inactive") {
                            navigate("/make-payment");
                        }

                    } else {
                        setPumpName("Complete Profile");
                    }
                    setLoading(false);
                });

                return () => unsubscribeDoc();
            } else {
                setPumpName("Guest");
                setLoading(false);
            }
        });

        return () => unsubscribeAuth();
    }, [navigate]);

    const signOut = () => {
        auth.signOut().then(() => {
            window.location.href = "/login";
        });
    };

    return (
        <nav className="main-header navbar navbar-expand navbar-orange navbar-light" style={{ backgroundColor: "orangered" }}>
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="#0" role="button">
                        <i style={{ color: "white" }} className="fas fa-bars" />
                    </a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <a className="nav-link" href="#0">
                        <b style={{ color: "white", textTransform: "uppercase", fontSize: "1.1rem" }}>
                            {loading ? <i className="fas fa-spinner fa-spin mr-2"></i> : pumpName}
                        </b>
                    </a>
                </li>
            </ul>

            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                    <a className="nav-link" data-widget="fullscreen" href="#0" role="button">
                        <i style={{ color: "white" }} className="fas fa-expand-arrows-alt" />
                    </a>
                </li>
                <li className="nav-item">
                    <button className="btn nav-link" onClick={() => window.history.back()}>
                        <i style={{ color: "white" }} className="fas fa-backward" />
                    </button>
                </li>
                <li className="nav-item">
                    <button className="btn nav-link" onClick={() => window.history.forward()}>
                        <i style={{ color: "white" }} className="fas fa-forward" />
                    </button>
                </li>
                <li className="nav-item">
                    <button className="btn nav-link" onClick={signOut}>
                        <i style={{ color: "white" }} className="fas fa-sign-out-alt" />
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default Header;